module.exports = __webpack_public_path__ + "img/hero-top.eefa9223.png";